var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWwtLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m67.398 43.107 12.507 12.718a.555.555 0 0 0 .396.163h15.638a.546.546 0 0 0 .514-.344.571.571 0 0 0-.118-.614l-20.34-20.668L88.5 21.644a.56.56 0 0 0 .12-.611.562.562 0 0 0-.12-.182l-7.815-7.95a.552.552 0 0 0-.603-.122.551.551 0 0 0-.179.122L46.295 47.08a.563.563 0 0 0-.124.622c.029.069.071.131.124.184l7.817 7.948a.551.551 0 0 0 .603.122.551.551 0 0 0 .179-.122l12.505-12.728Z",
    fill: "#0086EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m66.634.165-12.132 12.34L42.364.164A.552.552 0 0 0 41.968 0H26.33a.546.546 0 0 0-.517.345.57.57 0 0 0 .12.615l19.972 20.288-4.3 4.372L16.58.166A.558.558 0 0 0 16.182 0H.556a.548.548 0 0 0-.513.346A.573.573 0 0 0 .16.96L41.216 42.71a.552.552 0 0 0 .395.17.545.545 0 0 0 .396-.17L83.05.96a.567.567 0 0 0-.396-.96H67.014a.546.546 0 0 0-.395.165M92.425.165l-7.442 7.57a.562.562 0 0 0-.163.397.569.569 0 0 0 .163.398l7.817 7.948a.549.549 0 0 0 .6.122.549.549 0 0 0 .18-.122L108.84.96a.568.568 0 0 0-.088-.866.55.55 0 0 0-.308-.094H92.805c-.148 0-.29.06-.395.165",
    fill: "#EE282A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwtLogo);
export default __webpack_public_path__ + "static/media/wwt-logo.b66686db42224dc1dd13c21885387e68.svg";
export { ForwardRef as ReactComponent };